var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiningArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.875,
    y: 33.2916,
    width: 35.25,
    height: 3.91667,
    rx: 1.95833,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.165 30.0037C36.6026 31.0601 36.9053 32.1647 37.0679 33.2913H39.044C38.8695 31.9069 38.5105 30.5489 37.9743 29.2543C37.187 27.3535 36.033 25.6265 34.5782 24.1717C33.1234 22.7169 31.3963 21.5629 29.4955 20.7756C27.5948 19.9882 25.5575 19.583 23.5002 19.583C21.4428 19.583 19.4056 19.9882 17.5048 20.7756C15.604 21.5629 13.8769 22.7169 12.4222 24.1717C10.9674 25.6265 9.81337 27.3535 9.02605 29.2543C8.4898 30.5489 8.1308 31.9069 7.95637 33.2913H9.93243C10.0951 32.1647 10.3977 31.0601 10.8353 30.0037C11.5242 28.3406 12.534 26.8294 13.8069 25.5564C15.0798 24.2835 16.591 23.2737 18.2542 22.5848C19.9174 21.8959 21.7 21.5413 23.5002 21.5413C25.3004 21.5413 27.0829 21.8959 28.7461 22.5848C30.4093 23.2737 31.9205 24.2835 33.1934 25.5564C34.4664 26.8294 35.4761 28.3406 36.165 30.0037ZM7.8335 35.2497H9.79183L23.5002 35.2497L7.8335 35.2497Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5676 20.3882C25.5504 20.3052 25.532 20.2234 25.5124 20.1429C25.4037 19.6962 25.2585 19.2882 25.0824 18.936C24.8746 18.5204 24.6279 18.1907 24.3563 17.9657C24.0848 17.7408 23.7937 17.625 23.4998 17.625C23.2059 17.625 22.9149 17.7408 22.6434 17.9657C22.3718 18.1907 22.1251 18.5204 21.9173 18.936C21.7412 19.2882 21.596 19.6962 21.4873 20.1429C21.4677 20.2234 21.4493 20.3052 21.4321 20.3882C21.3555 20.7581 21.3042 21.1461 21.2793 21.5417H25.7204C25.6955 21.1461 25.6442 20.7581 25.5676 20.3882Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9691 9.79163C13.5888 10.6447 13.8554 11.704 13.7133 12.7487C13.4 14.2958 11.9312 14.707 11.755 16.1758C11.7265 16.7249 11.8207 17.2734 12.0307 17.7815C12.2407 18.2896 12.5613 18.7446 12.9691 19.1133",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.761 5.875C23.0774 6.28919 23.3079 6.76235 23.439 7.26676C23.5702 7.77117 23.5993 8.29668 23.5248 8.8125C23.2115 10.3792 21.7427 10.7708 21.5665 12.2592C21.5341 12.8069 21.6246 13.3549 21.8313 13.8631C22.038 14.3714 22.3556 14.827 22.761 15.1967",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5356 9.79163C32.8545 10.2082 33.0864 10.6847 33.2176 11.1927C33.3488 11.7006 33.3766 12.2298 33.2994 12.7487C32.9861 14.2958 31.5173 14.707 31.3411 16.1758C31.3054 16.7257 31.3963 17.2764 31.6067 17.7857C31.8172 18.2949 32.1417 18.7491 32.5552 19.1133",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiningArea);
export default __webpack_public_path__ + "static/media/dining_area.02a7d8a910b2223d011dc2a4b87ee183.svg";
export { ForwardRef as ReactComponent };